import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const CREATE_ENTERPRISE_PANEL_NAME = 'createEnterprisePanel';

@Injectable({ providedIn: 'root' })
export class CreateEnterprisePanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(
        CREATE_ENTERPRISE_PANEL_NAME,
      );
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  emitResult(result: any | false): void {
    const sidebar = this._fuseSidebarService.getSidebar(
      CREATE_ENTERPRISE_PANEL_NAME,
    );
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._isOpen$.next(false);
  }
}
